import { useReviewStore } from "../stores/review-store";

export const useReviews = () => {
	const reviews = useReviewStore((state) => state.reviews);
	const createReview = useReviewStore((state) => state.create);
	const showReview = useReviewStore((state) => state.show);
	const getReviewsByIds = useReviewStore((state) => state.getByIds);
	const indexReviews = useReviewStore((state) => state.index);
	const indexDrafts = useReviewStore((state) => state.indexDrafts);
	const indexReviewsForWallOfLove = useReviewStore((state) => state.indexForWallOfLove);
	const updateReview = useReviewStore((state) => state.update);
	const deleteReview = useReviewStore((state) => state.delete);
	const approveReview = useReviewStore((state) => state.approve);
	const unapproveReview = useReviewStore((state) => state.unapprove);
	const getStatusCounts = useReviewStore((state) => state.statusCounts);

	return {
		reviews,
		createReview,
		showReview,
		getReviewsByIds,
		indexReviews,
		indexDrafts,
		indexReviewsForWallOfLove,
		updateReview,
		deleteReview,
		approveReview,
		unapproveReview,
		getStatusCounts,
	};
};
